import { ERR_IMAGE_UPLOAD_ASPECT_RATIO } from '../constants/Errors';

const imageARCache = {};
/**
 * This function caclulates the uploaded image's aspect ratio. The aspect ratio is used in order to update the image height when needed.
 * @param {string} src - Source of the uploaded image
 * @returns {promise} - Promise that contains the image ratio of a uploaded image.
 */
export default function (src) {
    return new Promise((resolve, reject) => {
        if (src === 'PLACE_HOLDER') {
            resolve(null);
            return;
        }
        // eslint-disable-next-line no-prototype-builtins
        if (imageARCache.hasOwnProperty(src)) {
            resolve(imageARCache[src]);
            return;
        }

        const img = new Image();
        // eslint-disable-next-line func-names
        img.onload = function () {
            if (+this.width > 0 && +this.height > 0) {
                imageARCache[src] = parseFloat(+this.width / +this.height);
                resolve(imageARCache[src]);
            } else {
                reject(new Error(ERR_IMAGE_UPLOAD_ASPECT_RATIO));
            }
        };
        img.onerror = (err, data) => {
            // eslint-disable-next-line no-console
            console.error(err, data);
            reject(new Error(ERR_IMAGE_UPLOAD_ASPECT_RATIO));
        };
        img.src = src;
    });
}
